export default {
  center: {
    textAlign: 'center'
  },
  checkbox: {
    height: '20px',
    width: '20px',
    borderRadius: '4px'
  },
  date: {
    width: '80px'
  },
  conclusion: {
    width: '30px',
    height: '30px',
    borderRadius: '30px'
  },
  contextMenu: {
    width: '40px',
    height: '40px',
    borderRadius: '4px',
    display: 'inline-block'
  },
  contributors: {
    width: '82px',
    borderRadius: '30px'
  }
}
